import { render, staticRenderFns } from "./SelectProject.vue?vue&type=template&id=361f8f99&scoped=true"
import script from "./SelectProject.vue?vue&type=script&lang=js"
export * from "./SelectProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361f8f99",
  null
  
)

export default component.exports